export class Constants {
  static displayCount(mobile: boolean): number {
    return mobile ? Constants.MOBILE_DISPLAY_COUNT : Constants.DESKTOP_DISPLAY_COUNT;
  }

  static loadMoreCount(mobile: boolean): number {
    return mobile ? Constants.MOBILE_LOAD_MORE_COUNT : Constants.DESKTOP_LOAD_MORE_COUNT;
  }

  static waterfallLoadMoreCount(mobile: boolean): number {
    return mobile ? Constants.MOBILE_WATERFALL_LOAD_MORE_COUNT : Constants.DESKTOP_WATERFALL_LOAD_MORE_COUNT;
  }

  static CLIENT_VERSION = '1';
  static API_VERSION = 'v1';
  static APP_CONTAINER_WIDTH = 1180;
  static DESKTOP_HEADER_HEIGHT = 120;
  static APP_TABLET_CONTAINER_WIDTH = 820;
  static APP_TABLET_CONTAINER_HEIGHT = 1180;
  static APP_MOBILE_CONTAINER_WIDTH = 412;
  static APP_MOBILE_CONTAINER_HEIGHT = 700;
  static MOBILE_BOTTOM_BAR_HEIGHT = 47;
  static MOBILE_CART_FOOTER_HEIGHT = 55;
  static MOBILE_HEADER_BAR_WITH_TAB_HEIGHT = 83.5;
  static FLOAT_BOTTOM_BUTTONS_MARGIN = 34;
  static MAX_DISPLAY_COUNT = 1000;
  static DEFAULT_BUY_ALL_TAG_HEIGHT = 60;
  static DEFAULT_BUY_ALL_TAG_WIDTH = 150;
  static OUTFIT_DISPLAY_COUNT = 24;
  static ORDER_DISPLAY_COUNT = 20;
  static DESKTOP_DISPLAY_COUNT = 40;
  static DESKTOP_LOAD_MORE_COUNT = 30;
  static DESKTOP_WATERFALL_LOAD_MORE_COUNT = 10;
  static MOBILE_DISPLAY_COUNT = 10;
  static MOBILE_LOAD_MORE_COUNT = 10;
  static MOBILE_CART_LOAD_MORE_COUNT = 10;
  static MOBILE_WATERFALL_LOAD_MORE_COUNT = 3;
  static PAGE_TITLE = 'lativ 米格國際';
  static LINK_URL_HOST = 'https://www.lativ.com.tw';
  static DOMAIN = 'lativ.com.tw';
  static WEBVIEW = 'lativ.com.tw/webview';
  static LINE_BREAK_PATTERN = /[\n\r]|(\\n)/g;
  static MOBILE_DISPLAY_COLOR_COUNT = 6;
  static MOBILE_ORDER_BUTTON_COUNT = 3;
  static DESKTOP_ORDER_BUTTON_COUNT = 6;
  static MAX_CART_ITEM_COUNT = 50;
  static VERIFICATION_CODE_SIZE = 4;
  static ANDROID_PACKAGE_NAME = 'tw.com.lativ.shopping';
  static IOS_REDIRECT_URL = 'https://itunes.apple.com/tw/app/id1274334474';
  static SHARE_FACEBOOK_LINK = 'https://www.facebook.com/dialog/share?';
  static SHARE_LINE_LINK = 'https://line.naver.jp/R/msg/text/?';
  static APP_PACKAGE_SCHEME = 'lativprod';
  static APP_SCHEME_URL = 'lativprod://www.lativ.com.tw';
  static AD_TRACKING_ID = 'adTrackingId';
  static AD_TRACKING_ID_LENGTH = 10;
  static AD_SEQ = 'adSeq';
  static APPLE_APP_ID = '1274334474';
  static LEGACY_TOKEN = 'legacyToken';
  static LEGACY_DEVICE_ID = 'legacyDeviceId';
}
